import React, { useMemo, forwardRef } from 'react'
import { getTokenValue, Token, Spinner as TSpinner, useTheme } from 'tamagui'
import { useLingui } from '@lingui/react/macro'

export const Spinner = forwardRef<
  typeof TSpinner,
  { color: Token; size: Token }
>(({ color, size, ...props }, ref) => {
  const { t } = useLingui()
  const theme = useTheme()

  const parsedColor = useMemo(() => {
    if (typeof color === 'string' && color.startsWith('$')) {
      const themeKey = color.slice(1)
      const themeValue = theme[themeKey]?.val
      if (themeValue) return themeValue
    }
    return getTokenValue(color, 'color')
  }, [color, theme])

  const parsedSize = useMemo(() => {
    return getTokenValue(size, 'size')
  }, [size])

  return (
    <TSpinner
      ref={ref}
      {...props}
      size={parsedSize}
      color={parsedColor}
      aria-label={t`Loading...`}
    />
  )
})
